import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText as PrimeInputText } from 'primereact/inputtext'
import { Fieldset } from 'primereact/fieldset'
import { connect } from 'react-redux'

import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { Badge, Btn, Cnpj, InputText, ThreeDots } from '../../../../../components'
import ModalApontamentoFaltaManual from './ModalApontamentoFaltaManual/ModalApontamentoFaltaManual'
import { tableCellCentered } from '../../../../../assets/js/styles'
import * as colors from '../../../../../assets/js/colors'
import useFaltasManual, { LOAD_MESSAGE } from './FaltasManualPorIdentificadorHook'

function FaltasManualPorIdentificador({ dispatch, selectedPicking, missing_products }) {
  const { state, localDispatch } = useFaltasManual()

  useEffect(() => {
    localDispatch.onInit(missing_products)
  }, [missing_products])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE_MISSINGS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.saveFaltasSeparacaoManual(
          localDispatch.getFalta(state.entregasOriginais),
          selectedPicking.id,
        )
        break

      case LOAD_MESSAGE.SAVE_MISSINGS_SUCCESS:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <div style={{ textAlign: 'left' }}>
      <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
      <PrimeInputText
        value={state.globalFilter}
        type="search"
        onInput={e => localDispatch.onGlobalFilterChange(e.target.value)}
        placeholder="Pesquisar . . ."
        size="50"
      />
    </div>
  )

  const identificadorColWidth =
    state.entregas.length > 0
      ? Math.max(
          160,
          Math.max(...state.entregas.map(entrega => String(entrega.identifier || '').length)) * 9,
        )
      : 160

  return (
    <React.Fragment>
      <Fieldset
        legend="Filtro"
        toggleable
        collapsed={true}
        className="p-col-12"
        style={{ marginBottom: 20 }}
      >
        <div className="p-grid p-align-center">
          <div className="p-col-4">
            <InputText
              label="Código do Produto"
              value={state.codigoProduto}
              onChange={localDispatch.onCodigoProdutoChange}
              onEnter={localDispatch.onBuscarPorCodigoProduto}
            />
          </div>
          <div className="p-col-1" style={{ marginTop: 32 }}>
            <Btn onClick={localDispatch.onBuscarPorCodigoProduto}>Buscar</Btn>
          </div>
          <div className="p-col-1" style={{ marginTop: 32 }}>
            <Btn onClick={localDispatch.onLimparFiltroProduto}>Limpar</Btn>
          </div>
        </div>
      </Fieldset>
      <DataTable
        value={state.entregas}
        paginator={true}
        rows={10}
        header={header}
        globalFilter={state.globalFilter}
        emptyMessage="Nenhuma entrega encontrada"
        tableStyle={{ tableLayout: 'fixed', width: '100%' }}
      >
        <Column
          header="Falta"
          style={tableCellCentered(80)}
          body={entrega => {
            return entrega.has_missing_product ? (
              <Badge color={colors.error}>Sim</Badge>
            ) : (
              <Badge color={colors.azul}>Não</Badge>
            )
          }}
        />
        <Column
          field="identifier"
          header="Identificador"
          style={{
            ...tableCellCentered(identificadorColWidth),
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        />
        <Column
          field="nome_fantasia"
          header="Nome Fantasia"
          style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        />
        <Column
          field="city"
          header="Cidade"
          style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        />
        <Column
          field="district"
          header="Bairro"
          style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        />
        <Column
          field="cnpj"
          header="CNPJ"
          style={tableCellCentered(180)}
          body={entrega => <Cnpj>{entrega.cnpj}</Cnpj>}
        />
        <Column field="qte_sku" header="Qte. SKU" style={tableCellCentered(80)} />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={entrega => (
            <ThreeDots
              items={['Faltas']}
              onClick={item => localDispatch.onMenuItemClicked(entrega)}
            />
          )}
          bodyStyle={tableCellCentered()}
        />
      </DataTable>
      {state.modal.show ? (
        <ModalApontamentoFaltaManual
          show={state.modal.show}
          onModalClose={localDispatch.onModalClose}
          onModalSave={localDispatch.onModalSave}
          data={state.modal.data}
        />
      ) : null}
    </React.Fragment>
  )
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(FaltasManualPorIdentificador)
